/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TombstoneRip} from "../TombstoneRip";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {TombstoneRipGameMode} from "./TombstoneRipGameMode";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";

export class TombstoneRipNormalIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        flowStateController.setSkipCallback(() => this.skip(flowStateController))

        TombstoneRip.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
        });

        TombstoneRip.xBetController.featureVisible = true;
        if(!TombstoneRip.autoPlayPlugin.isAutoplayRound) {
            TombstoneRip.xBetController.buttonEnabled = true;
        }

        if(!TombstoneRip.model.parsedGameData) {
            // game init idle.
            return;
        }

        if(TombstoneRip.background.currentMode != GameMode.NORMAL) {
            if(TombstoneRip.background.currentMode === TombstoneRipGameMode.NORMAL_SUPER &&
                TombstoneRip.model.parsedGameData.currentWinRatioConfig?.bigWinLevel === -1
            ) {
                TombstoneRipSound.fadeAndStopSound({
                    name : TombstoneRipSound.RESPIN_LOOP,
                    to : 0,
                    duration : 300
                });
            }
            TombstoneRip.background.updateEnvironment(GameMode.NORMAL);
            TombstoneRip.reels.forEach(reel => {
                reel.resetSuperMidSymbol();
            });
            TombstoneRip.superFsPop.reset();
        }

        // only for init without restore.
        if(TombstoneRip.model.gameData?.nextMode != GameMode.NORMAL) {
            flowStateController.finish();
            TombstoneRip.idle.start();
            return;
        }

        if(!BelowStakeWinRestriction.isWinBelowPlayedBetValue()) {
            TombstoneRip.individualWin.start();
        }

        if(TombstoneRip.model.parsedGameData.singleWin === 0 &&
            TombstoneRip.model.parsedGameData.nextMode === GameMode.NORMAL &&
            !TombstoneRip.autoPlayPlugin.isAutoplayRound
        ) {
            TombstoneRip.idle.start();
        }

        BelowStakeWinRestriction.reset();
    }

    private async skip(flowStateController:FlowStateController):Promise<any> {
        await TombstoneRip.individualWin.stop();
        flowStateController.finish();
    }
}